<script>
  import { Header } from 'element-ui'
  export default {
    name:'ElHeader',
    extends:Header
  }
</script>
